import {
  SUPPORTED_DOCUMENT_TYPES,
  SUPPORTED_EXTENSIONS
} from '../../../utils/fileUploadValidation';

export const supportedFiles = {
  // Display labels derived from the shared source of truth.
  fileName: SUPPORTED_EXTENSIONS.map((extension) => extension.toUpperCase()),
  // Flat list of MIME types the backend accepts, kept in lockstep with the
  // shared validation module so the UI and backend never drift.
  acceptFile: Object.values(SUPPORTED_DOCUMENT_TYPES).flat()
};

export const uploadFileLimits = {
  default: { max: 10, min: 0 },
  internal: { max: 2, min: 2 },
  other: { max: 1, min: 1 }
};

export const radioButtonCardOptions = [
  {
    label: 'Internal Assessment',
    description:
      'Self-assessment for systems not requiring third-party certification.',
    documentRequirement: ['Quality Management System', 'Post Market Monitoring']
  },
  {
    label: 'External Assessment',
    description:
      'Third-party certification(Notified Body) for high-risk systems in regulated sectors.',
    documentRequirement: ['Conformity Assessment Certificate']
  }
];

export const friaOptionsCardOptions = [
  {
    label: 'Generate FRIA',
    description:
      'Create a new Fundamental Rights Impact Assessment document using AI assistance.',
    documentRequirement: []
  },
  {
    label: 'Upload FRIA',
    description:
      'Upload an existing Fundamental Rights Impact Assessment document.',
    documentRequirement: []
  }
];

export const dpiaOptionsCardOptions = [
  {
    label: 'Generate DPIA',
    description:
      'Create a new Data Protection Impact Assessment document using AI assistance.',
    documentRequirement: []
  },
  {
    label: 'Upload DPIA',
    description:
      'Upload an existing Data Protection Impact Assessment document.',
    documentRequirement: []
  }
];
